import "./Contact.module.css";
import Intestazione from "@/reusable_sections/Header";
import RimaniamoInContatto from "./sections/RimaniamoInContatto";
import LaNostraPosizione from "./sections/LaNostraPosizione";
import PieDiPagina from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Intestazione />
      <RimaniamoInContatto />
      <LaNostraPosizione />
      <PieDiPagina />
    </div>;
}